import { IOException1wyutdmfe71nu as IOException } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnsupportedMediaTypeExceptionCIOClass;
function UnsupportedMediaTypeExceptionCIO() {
  if (UnsupportedMediaTypeExceptionCIOClass === VOID) {
    class $ extends IOException() {
      static m58(message) {
        var $this = this.l4h(message);
        captureStack($this, $this.l58_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsupportedMediaTypeExceptionCIO');
    UnsupportedMediaTypeExceptionCIOClass = $;
  }
  return UnsupportedMediaTypeExceptionCIOClass;
}
//region block: exports
export {
  UnsupportedMediaTypeExceptionCIO as UnsupportedMediaTypeExceptionCIOasihkge9oc44,
};
//endregion

//# sourceMappingURL=Errors.mjs.map
